// Libraries
import { get } from 'lodash'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

// Common components
import { TableLayout } from 'Components'

// Specs
import { TableSpecs } from 'Views/SecurityMeasures/Specs'

// Styles
import './Styles/List.less'

class SecurityMeasuresList extends Component {
  static propTypes = {
    // TÃ©moin d'approvisionnement des donnÃ©es
    loading: PropTypes.bool,

    // DonnÃ©es de la vue
    dataList: PropTypes.array,

    // DonnÃ©es de construction du tableau
    TableSpecs: PropTypes.object,

    // Fonctions hÃ©ritÃ©s du constructeur
    constructorFunctions: PropTypes.objectOf(PropTypes.func)
  }

  static defaultProps = {
    // TÃ©moin d'approvisionnement des donnÃ©es
    loading: true,

    // DonnÃ©es de la vue
    dataList: []
  }

  constructor(props) {
    super(props)

    this.state = {
      pagination: TableSpecs.pagination
    }
  }

  handleOnChange = pagination => {
    this.setState({ pagination })
  }

  render() {
    const { loading, dataList, constructorFunctions } = this.props
    const { pagination } = this.state

    // Ajout des donnÃ©es au tableau
    TableSpecs.rows = dataList

    // Ajout des actions au clic sur un ligne du tableau
    TableSpecs.onRow = (securityMeasure, id) => ({
      onClick: () =>
        get(constructorFunctions, 'handleRowClick', () => {})(
          securityMeasure,
          id
        )
    })

    // Pagination courante
    TableSpecs.pagination = pagination
    TableSpecs.onChange = this.handleOnChange

    TableSpecs.onDraggedRowReleased = draggedData =>
      get(constructorFunctions, 'handleDraggedRowReleased', () => {})(
        draggedData
      )

    // Ajout des actions multiples sur le tableau
    TableSpecs.actions.selection.delete.onClick = get(
      constructorFunctions,
      'askDeleteManySecurityMeasures'
    )

    // Ajout des actions des boutons
    TableSpecs.actions.global.create.onClick = get(
      constructorFunctions,
      'askCreateSecurityMeasure'
    )

    return (
      <main className='screen securityMeasures securityMeasures-list'>
        <TableLayout loading={loading} {...TableSpecs} />
      </main>
    )
  }
}

export default SecurityMeasuresList
